import { useContext, useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { useDeps } from 'src/hooks/useDeps';
import { MediaEntry } from 'src/types/global-types';
import { productList, productListVariables } from 'src/queries/__generated__/productList';
import { productDetail_productDetail_media_gallery } from 'src/queries/__generated__/productDetail';

import productListMediaGalleryQuery from '../../../queries/productListMediaGallery.graphql';
import { ProductOptionsContext } from '../ProductOptionsProvider';
import { cleanMediaEntries } from '../utils/product-detail.types';

export function useInitialGalleryMedia(fallback: MediaEntry[]): MediaEntry[] {
    const { baseVariants } = useContext(ProductOptionsContext);
    const sku = baseVariants[0]?.sku;
    const { data, previousData } = useQuery<productList, productListVariables>(productListMediaGalleryQuery, {
        variables: { skus: sku ? [sku] : [] },
        skip: !sku,
        ssr: useDeps().env.SSR_GQL,
    });
    const media = (data ?? previousData)?.productList?.[0]?.media_gallery;

    return useMemo(
        () =>
            media && media.length > 0
                ? cleanMediaEntries(media as productDetail_productDetail_media_gallery[])
                : fallback,
        [media, fallback],
    );
}
